import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
  pendo: any = {};
  UNSUFFICIENT_PERMISSION = 'Please contact ReedTech Support to get additional permissions';
  GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
  applicationName = 'SingleSource';

  ERROR_CODE_FORBIDDEN = '403';
  FORBIDDEN_ERROR_MESSAGE = 'Sorry, you don\'t have enough permission to access the feature/page.';

  ERROR_CODE_NOT_FOUND = '404';
  NOT_FOUND_ERROR_MESSAGE = 'Sorry, the resource is not available. Please try again later.'
  PAGE_NOT_FOUND = 'Sorry, the page is not found.'

  ERROR_CODE_UNAUTHORIZED = '401';
  NOT_AUTHORIZED_ERROR_MESSAGE = 'Sorry, you\'re not authorized.';

  ERROR_CODE_GENERIC_ERROR = '500';
  GENERIC_HTTP_ERROR_MESSAGE = 'Sorry, the server encountered an unexpected error. Please try again later.'

  permissions = {
    ApiAccess: 'SS.ApiAccess',
    CanAccessChannelSupportDocuments: 'SS.CanAccessChannelSupportDocuments',
    CanAccessClientAdminSettings: 'SS.CanAccessClientAdminSettings',
    CanCreateData: 'SS.CanCreateData',
    CanDeactivateRecord: 'SS.CanDeactivateRecord',
    CanReadData: 'SS.CanReadData',
    CanRejectData: 'SS.CanRejectData',
    CanSendDataForSubmissionApproval: 'SS.CanSendDataForSubmissionApproval',
    CanSubmitData: 'SS.CanSubmitData',
    CanUpdateRecord: 'CanUpdateRecord',
    CanUpdateDeviceData: 'SS.CanUpdateDeviceData',
    CanUploadFile: 'SS.CanUploadFile',
    CanUpdateModelData: 'SS.CanUpdateModelData',
    CanUpdateApiCredentials: 'SS.CanUpdateApiCredentials',
    ServiceCall: 'SS.ServiceCall',
    CreateEditExportTemplate: 'SS.CreateEditExportTemplate',
    ExecuteExportDownloadTemplate: 'SS.ExecuteExportDownloadTemplate',
    DeleteExportTemplate: 'SS.DeleteExportTemplate',
    CanEditLanguageSettings: 'SS.CanEditLanguageSettings'
  };
}

